import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4847caa6 = () => interopDefault(import('../../../pages/auth/callback.vue' /* webpackChunkName: "pages/auth/callback" */))
const _ae396280 = () => interopDefault(import('../../../pages/auth/home.vue' /* webpackChunkName: "pages/auth/home" */))
const _2e6880e7 = () => interopDefault(import('../../../pages/_affiliate/index.vue' /* webpackChunkName: "pages/_affiliate/index" */))
const _5fd7d4e4 = () => interopDefault(import('../../../pages/_affiliate/admin.vue' /* webpackChunkName: "pages/_affiliate/admin" */))
const _86fbbf32 = () => interopDefault(import('../../../pages/_affiliate/admin/index.vue' /* webpackChunkName: "pages/_affiliate/admin/index" */))
const _497398e5 = () => interopDefault(import('../../../pages/_affiliate/admin/coupons/index.vue' /* webpackChunkName: "pages/_affiliate/admin/coupons/index" */))
const _2df57af3 = () => interopDefault(import('../../../pages/_affiliate/admin/cremations/index.vue' /* webpackChunkName: "pages/_affiliate/admin/cremations/index" */))
const _ef4ca5f2 = () => interopDefault(import('../../../pages/_affiliate/admin/end-of-life-categories/index.vue' /* webpackChunkName: "pages/_affiliate/admin/end-of-life-categories/index" */))
const _4270803a = () => interopDefault(import('../../../pages/_affiliate/admin/generic-checkout/index.vue' /* webpackChunkName: "pages/_affiliate/admin/generic-checkout/index" */))
const _7abfb039 = () => interopDefault(import('../../../pages/_affiliate/admin/institutions/index.vue' /* webpackChunkName: "pages/_affiliate/admin/institutions/index" */))
const _51c93b6d = () => interopDefault(import('../../../pages/_affiliate/admin/partnerships/index.vue' /* webpackChunkName: "pages/_affiliate/admin/partnerships/index" */))
const _11f3b186 = () => interopDefault(import('../../../pages/_affiliate/admin/reporting/index.vue' /* webpackChunkName: "pages/_affiliate/admin/reporting/index" */))
const _57881b7f = () => interopDefault(import('../../../pages/_affiliate/admin/submissions/index.vue' /* webpackChunkName: "pages/_affiliate/admin/submissions/index" */))
const _00875760 = () => interopDefault(import('../../../pages/_affiliate/admin/users/index.vue' /* webpackChunkName: "pages/_affiliate/admin/users/index" */))
const _026c908d = () => interopDefault(import('../../../pages/_affiliate/admin/coupons/_id.vue' /* webpackChunkName: "pages/_affiliate/admin/coupons/_id" */))
const _a308c3ca = () => interopDefault(import('../../../pages/_affiliate/admin/cremations/_id.vue' /* webpackChunkName: "pages/_affiliate/admin/cremations/_id" */))
const _4ead452f = () => interopDefault(import('../../../pages/_affiliate/admin/end-of-life-categories/_id.vue' /* webpackChunkName: "pages/_affiliate/admin/end-of-life-categories/_id" */))
const _fe83263e = () => interopDefault(import('../../../pages/_affiliate/admin/institutions/_id.vue' /* webpackChunkName: "pages/_affiliate/admin/institutions/_id" */))
const _d94d95d6 = () => interopDefault(import('../../../pages/_affiliate/admin/partnerships/_id.vue' /* webpackChunkName: "pages/_affiliate/admin/partnerships/_id" */))
const _1914f1a7 = () => interopDefault(import('../../../pages/_affiliate/admin/submissions/_id.vue' /* webpackChunkName: "pages/_affiliate/admin/submissions/_id" */))
const _72c3b1c8 = () => interopDefault(import('../../../pages/_affiliate/admin/users/_id.vue' /* webpackChunkName: "pages/_affiliate/admin/users/_id" */))
const _4cd2bd7e = () => interopDefault(import('../../../pages/_affiliate/checkout.vue' /* webpackChunkName: "pages/_affiliate/checkout" */))
const _07743268 = () => interopDefault(import('../../../pages/_affiliate/checkout/generic/index.vue' /* webpackChunkName: "pages/_affiliate/checkout/generic/index" */))
const _1d4a21b8 = () => interopDefault(import('../../../pages/_affiliate/checkout/gifts/index.vue' /* webpackChunkName: "pages/_affiliate/checkout/gifts/index" */))
const _6aeaa277 = () => interopDefault(import('../../../pages/_affiliate/checkout/poa/index.vue' /* webpackChunkName: "pages/_affiliate/checkout/poa/index" */))
const _2fd22f85 = () => interopDefault(import('../../../pages/_affiliate/checkout/unlock/index.vue' /* webpackChunkName: "pages/_affiliate/checkout/unlock/index" */))
const _306eb149 = () => interopDefault(import('../../../pages/_affiliate/checkout/update-card/index.vue' /* webpackChunkName: "pages/_affiliate/checkout/update-card/index" */))
const _520b0fda = () => interopDefault(import('../../../pages/_affiliate/checkout/will/index.vue' /* webpackChunkName: "pages/_affiliate/checkout/will/index" */))
const _23f564bf = () => interopDefault(import('../../../pages/_affiliate/checkout/generic/thanks.vue' /* webpackChunkName: "pages/_affiliate/checkout/generic/thanks" */))
const _5a3870bc = () => interopDefault(import('../../../pages/_affiliate/checkout/gifts/thank-you.vue' /* webpackChunkName: "pages/_affiliate/checkout/gifts/thank-you" */))
const _23788753 = () => interopDefault(import('../../../pages/_affiliate/checkout/gifts/thanks.vue' /* webpackChunkName: "pages/_affiliate/checkout/gifts/thanks" */))
const _66c7d0e1 = () => interopDefault(import('../../../pages/_affiliate/checkout/poa/thank-you.vue' /* webpackChunkName: "pages/_affiliate/checkout/poa/thank-you" */))
const _ec2fc318 = () => interopDefault(import('../../../pages/_affiliate/checkout/poa/thanks.vue' /* webpackChunkName: "pages/_affiliate/checkout/poa/thanks" */))
const _61f23326 = () => interopDefault(import('../../../pages/_affiliate/checkout/unlock/thanks.vue' /* webpackChunkName: "pages/_affiliate/checkout/unlock/thanks" */))
const _74e5e9e2 = () => interopDefault(import('../../../pages/_affiliate/checkout/update-card/thanks.vue' /* webpackChunkName: "pages/_affiliate/checkout/update-card/thanks" */))
const _15090f06 = () => interopDefault(import('../../../pages/_affiliate/checkout/will/thank-you.vue' /* webpackChunkName: "pages/_affiliate/checkout/will/thank-you" */))
const _c05a0750 = () => interopDefault(import('../../../pages/_affiliate/checkout/will/thanks.vue' /* webpackChunkName: "pages/_affiliate/checkout/will/thanks" */))
const _5e521020 = () => interopDefault(import('../../../pages/_affiliate/cremations.vue' /* webpackChunkName: "pages/_affiliate/cremations" */))
const _33531014 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/index.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/index" */))
const _8ab4024c = () => interopDefault(import('../../../pages/_affiliate/cremations/complete-quote/index.vue' /* webpackChunkName: "pages/_affiliate/cremations/complete-quote/index" */))
const _5981956d = () => interopDefault(import('../../../pages/_affiliate/cremations/complete-quote/arrange-payment.vue' /* webpackChunkName: "pages/_affiliate/cremations/complete-quote/arrange-payment" */))
const _228a87b5 = () => interopDefault(import('../../../pages/_affiliate/cremations/complete-quote/contract-preview.vue' /* webpackChunkName: "pages/_affiliate/cremations/complete-quote/contract-preview" */))
const _2767df64 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/documentation/final/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/documentation/final/_id" */))
const _897db248 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/documentation/initial/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/documentation/initial/_id" */))
const _d9d43b3e = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/address/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/address/_id" */))
const _5d6a870d = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/authorisation/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/authorisation/_id" */))
const _9201ef2c = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/care/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/care/_id" */))
const _5e3dbb50 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/children/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/children/_id" */))
const _f1877266 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/deceased/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/deceased/_id" */))
const _186bafcb = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/informant/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/informant/_id" */))
const _1ac2e8fe = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/instructions/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/instructions/_id" */))
const _2ff22155 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/life/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/life/_id" */))
const _08d06e76 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/parents/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/parents/_id" */))
const _64b5b0c4 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/passing/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/passing/_id" */))
const _f4b0cdb0 = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/relationships/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/relationships/_id" */))
const _7ece077c = () => interopDefault(import('../../../pages/_affiliate/cremations/at-need/_id.vue' /* webpackChunkName: "pages/_affiliate/cremations/at-need/_id" */))
const _ba3fe9ae = () => interopDefault(import('../../../pages/_affiliate/dashboard.vue' /* webpackChunkName: "pages/_affiliate/dashboard" */))
const _6c17ceec = () => interopDefault(import('../../../pages/_affiliate/dashboard/index.vue' /* webpackChunkName: "pages/_affiliate/dashboard/index" */))
const _5951bf19 = () => interopDefault(import('../../../pages/_affiliate/dashboard/account-settings.vue' /* webpackChunkName: "pages/_affiliate/dashboard/account-settings" */))
const _4ed00611 = () => interopDefault(import('../../../pages/_affiliate/dashboard/files.vue' /* webpackChunkName: "pages/_affiliate/dashboard/files" */))
const _5baba424 = () => interopDefault(import('../../../pages/_affiliate/dashboard/invites.vue' /* webpackChunkName: "pages/_affiliate/dashboard/invites" */))
const _50639195 = () => interopDefault(import('../../../pages/_affiliate/end-of-life.vue' /* webpackChunkName: "pages/_affiliate/end-of-life" */))
const _15476388 = () => interopDefault(import('../../../pages/_affiliate/end-of-life/_rootcategory/index.vue' /* webpackChunkName: "pages/_affiliate/end-of-life/_rootcategory/index" */))
const _0b5e38d6 = () => interopDefault(import('../../../pages/_affiliate/end-of-life/_rootcategory/_category/index.vue' /* webpackChunkName: "pages/_affiliate/end-of-life/_rootcategory/_category/index" */))
const _5d74a6ee = () => interopDefault(import('../../../pages/_affiliate/end-of-life/_rootcategory/_category/_subcategory/index.vue' /* webpackChunkName: "pages/_affiliate/end-of-life/_rootcategory/_category/_subcategory/index" */))
const _03eeff4c = () => interopDefault(import('../../../pages/_affiliate/forgot-password.vue' /* webpackChunkName: "pages/_affiliate/forgot-password" */))
const _7c64e75f = () => interopDefault(import('../../../pages/_affiliate/get-started.vue' /* webpackChunkName: "pages/_affiliate/get-started" */))
const _16182aa2 = () => interopDefault(import('../../../pages/_affiliate/get-started/index.vue' /* webpackChunkName: "pages/_affiliate/get-started/index" */))
const _2ccd44cc = () => interopDefault(import('../../../pages/_affiliate/log-in/index.vue' /* webpackChunkName: "pages/_affiliate/log-in/index" */))
const _ecba7ecc = () => interopDefault(import('../../../pages/_affiliate/log-out.vue' /* webpackChunkName: "pages/_affiliate/log-out" */))
const _69e7b0e8 = () => interopDefault(import('../../../pages/_affiliate/maintenance.vue' /* webpackChunkName: "pages/_affiliate/maintenance" */))
const _157c4d97 = () => interopDefault(import('../../../pages/_affiliate/poa.vue' /* webpackChunkName: "pages/_affiliate/poa" */))
const _e02ff24c = () => interopDefault(import('../../../pages/_affiliate/poa/index.vue' /* webpackChunkName: "pages/_affiliate/poa/index" */))
const _a6ec5e32 = () => interopDefault(import('../../../pages/_affiliate/poa/about-yourself.vue' /* webpackChunkName: "pages/_affiliate/poa/about-yourself" */))
const _4179ce2a = () => interopDefault(import('../../../pages/_affiliate/poa/about-yourself/index.vue' /* webpackChunkName: "pages/_affiliate/poa/about-yourself/index" */))
const _6707f04c = () => interopDefault(import('../../../pages/_affiliate/poa/about-yourself/address.vue' /* webpackChunkName: "pages/_affiliate/poa/about-yourself/address" */))
const _06c1ea40 = () => interopDefault(import('../../../pages/_affiliate/poa/about-yourself/date-of-birth.vue' /* webpackChunkName: "pages/_affiliate/poa/about-yourself/date-of-birth" */))
const _344634c6 = () => interopDefault(import('../../../pages/_affiliate/poa/about-yourself/phone.vue' /* webpackChunkName: "pages/_affiliate/poa/about-yourself/phone" */))
const _a05361de = () => interopDefault(import('../../../pages/_affiliate/poa/financial.vue' /* webpackChunkName: "pages/_affiliate/poa/financial" */))
const _ca94f658 = () => interopDefault(import('../../../pages/_affiliate/poa/financial/index.vue' /* webpackChunkName: "pages/_affiliate/poa/financial/index" */))
const _663dbeca = () => interopDefault(import('../../../pages/_affiliate/poa/financial/limitations.vue' /* webpackChunkName: "pages/_affiliate/poa/financial/limitations" */))
const _234b11f7 = () => interopDefault(import('../../../pages/_affiliate/poa/financial/primary-decision-makers.vue' /* webpackChunkName: "pages/_affiliate/poa/financial/primary-decision-makers" */))
const _6288820e = () => interopDefault(import('../../../pages/_affiliate/poa/financial/primary-decisions.vue' /* webpackChunkName: "pages/_affiliate/poa/financial/primary-decisions" */))
const _4fec6fb2 = () => interopDefault(import('../../../pages/_affiliate/poa/financial/spending.vue' /* webpackChunkName: "pages/_affiliate/poa/financial/spending" */))
const _2b15347b = () => interopDefault(import('../../../pages/_affiliate/poa/financial/substitute-decision-makers.vue' /* webpackChunkName: "pages/_affiliate/poa/financial/substitute-decision-makers" */))
const _5f92d81b = () => interopDefault(import('../../../pages/_affiliate/poa/financial/substitutes.vue' /* webpackChunkName: "pages/_affiliate/poa/financial/substitutes" */))
const _dc08b5ce = () => interopDefault(import('../../../pages/_affiliate/poa/medical.vue' /* webpackChunkName: "pages/_affiliate/poa/medical" */))
const _e7979648 = () => interopDefault(import('../../../pages/_affiliate/poa/medical/index.vue' /* webpackChunkName: "pages/_affiliate/poa/medical/index" */))
const _17cdaaa3 = () => interopDefault(import('../../../pages/_affiliate/poa/medical/limitations.vue' /* webpackChunkName: "pages/_affiliate/poa/medical/limitations" */))
const _31914a82 = () => interopDefault(import('../../../pages/_affiliate/poa/medical/preferences.vue' /* webpackChunkName: "pages/_affiliate/poa/medical/preferences" */))
const _fc5e6002 = () => interopDefault(import('../../../pages/_affiliate/poa/medical/primary-decision-makers.vue' /* webpackChunkName: "pages/_affiliate/poa/medical/primary-decision-makers" */))
const _e0d133d4 = () => interopDefault(import('../../../pages/_affiliate/poa/medical/primary-decisions.vue' /* webpackChunkName: "pages/_affiliate/poa/medical/primary-decisions" */))
const _4e5b4d1a = () => interopDefault(import('../../../pages/_affiliate/poa/medical/substitute-decision-makers.vue' /* webpackChunkName: "pages/_affiliate/poa/medical/substitute-decision-makers" */))
const _ab013bba = () => interopDefault(import('../../../pages/_affiliate/poa/medical/substitutes.vue' /* webpackChunkName: "pages/_affiliate/poa/medical/substitutes" */))
const _372cc7b4 = () => interopDefault(import('../../../pages/_affiliate/verify.vue' /* webpackChunkName: "pages/_affiliate/verify" */))
const _49de874d = () => interopDefault(import('../../../pages/_affiliate/will.vue' /* webpackChunkName: "pages/_affiliate/will" */))
const _51a9a010 = () => interopDefault(import('../../../pages/_affiliate/will/index.vue' /* webpackChunkName: "pages/_affiliate/will/index" */))
const _a785e310 = () => interopDefault(import('../../../pages/_affiliate/will/assets/index.vue' /* webpackChunkName: "pages/_affiliate/will/assets/index" */))
const _e7cdf134 = () => interopDefault(import('../../../pages/_affiliate/will/charity-consent/index.vue' /* webpackChunkName: "pages/_affiliate/will/charity-consent/index" */))
const _16153ae4 = () => interopDefault(import('../../../pages/_affiliate/will/completion.vue' /* webpackChunkName: "pages/_affiliate/will/completion" */))
const _35d46f01 = () => interopDefault(import('../../../pages/_affiliate/will/estate/index.vue' /* webpackChunkName: "pages/_affiliate/will/estate/index" */))
const _3b2faf41 = () => interopDefault(import('../../../pages/_affiliate/will/executors/index.vue' /* webpackChunkName: "pages/_affiliate/will/executors/index" */))
const _02fd6598 = () => interopDefault(import('../../../pages/_affiliate/will/funeral/index.vue' /* webpackChunkName: "pages/_affiliate/will/funeral/index" */))
const _410d55c4 = () => interopDefault(import('../../../pages/_affiliate/will/gifts/index.vue' /* webpackChunkName: "pages/_affiliate/will/gifts/index" */))
const _335dac54 = () => interopDefault(import('../../../pages/_affiliate/will/about-yourself/address.vue' /* webpackChunkName: "pages/_affiliate/will/about-yourself/address" */))
const _2f15162c = () => interopDefault(import('../../../pages/_affiliate/will/about-yourself/date-of-birth.vue' /* webpackChunkName: "pages/_affiliate/will/about-yourself/date-of-birth" */))
const _96c5e2ce = () => interopDefault(import('../../../pages/_affiliate/will/about-yourself/name.vue' /* webpackChunkName: "pages/_affiliate/will/about-yourself/name" */))
const _7281e0aa = () => interopDefault(import('../../../pages/_affiliate/will/about-yourself/partner.vue' /* webpackChunkName: "pages/_affiliate/will/about-yourself/partner" */))
const _5ac448d0 = () => interopDefault(import('../../../pages/_affiliate/will/about-yourself/phone.vue' /* webpackChunkName: "pages/_affiliate/will/about-yourself/phone" */))
const _12a93dde = () => interopDefault(import('../../../pages/_affiliate/will/assets/liabilities.vue' /* webpackChunkName: "pages/_affiliate/will/assets/liabilities" */))
const _4791a4e7 = () => interopDefault(import('../../../pages/_affiliate/will/assets/notes.vue' /* webpackChunkName: "pages/_affiliate/will/assets/notes" */))
const _ce84fe1c = () => interopDefault(import('../../../pages/_affiliate/will/estate/beneficiaries.vue' /* webpackChunkName: "pages/_affiliate/will/estate/beneficiaries" */))
const _0388caa5 = () => interopDefault(import('../../../pages/_affiliate/will/estate/distribution.vue' /* webpackChunkName: "pages/_affiliate/will/estate/distribution" */))
const _2f7aca62 = () => interopDefault(import('../../../pages/_affiliate/will/estate/include-charity.vue' /* webpackChunkName: "pages/_affiliate/will/estate/include-charity" */))
const _6d9cf53a = () => interopDefault(import('../../../pages/_affiliate/will/executors/backup.vue' /* webpackChunkName: "pages/_affiliate/will/executors/backup" */))
const _088f6d4d = () => interopDefault(import('../../../pages/_affiliate/will/executors/options.vue' /* webpackChunkName: "pages/_affiliate/will/executors/options" */))
const _2da8ba9e = () => interopDefault(import('../../../pages/_affiliate/will/executors/primary.vue' /* webpackChunkName: "pages/_affiliate/will/executors/primary" */))
const _d726c0f8 = () => interopDefault(import('../../../pages/_affiliate/will/executors/primary-contact.vue' /* webpackChunkName: "pages/_affiliate/will/executors/primary-contact" */))
const _016b6502 = () => interopDefault(import('../../../pages/_affiliate/will/executors/professional-terms.vue' /* webpackChunkName: "pages/_affiliate/will/executors/professional-terms" */))
const _4c619442 = () => interopDefault(import('../../../pages/_affiliate/will/funeral/location.vue' /* webpackChunkName: "pages/_affiliate/will/funeral/location" */))
const _301ea08b = () => interopDefault(import('../../../pages/_affiliate/will/funeral/other-requests.vue' /* webpackChunkName: "pages/_affiliate/will/funeral/other-requests" */))
const _77805965 = () => interopDefault(import('../../../pages/_affiliate/will/gifts/include-charity.vue' /* webpackChunkName: "pages/_affiliate/will/gifts/include-charity" */))
const _284fcdbe = () => interopDefault(import('../../../pages/_affiliate/will/guardians/backup.vue' /* webpackChunkName: "pages/_affiliate/will/guardians/backup" */))
const _37359378 = () => interopDefault(import('../../../pages/_affiliate/will/guardians/pet-care-fund.vue' /* webpackChunkName: "pages/_affiliate/will/guardians/pet-care-fund" */))
const _a3e98a76 = () => interopDefault(import('../../../pages/_affiliate/will/guardians/pet-guardians.vue' /* webpackChunkName: "pages/_affiliate/will/guardians/pet-guardians" */))
const _1b5786b3 = () => interopDefault(import('../../../pages/_affiliate/will/guardians/primary.vue' /* webpackChunkName: "pages/_affiliate/will/guardians/primary" */))
const _f7848e6c = () => interopDefault(import('../../../pages/_affiliate/will/guardians/your-children.vue' /* webpackChunkName: "pages/_affiliate/will/guardians/your-children" */))
const _16c1fcff = () => interopDefault(import('../../../pages/_affiliate/will/guardians/your-pets.vue' /* webpackChunkName: "pages/_affiliate/will/guardians/your-pets" */))
const _0231a078 = () => interopDefault(import('../../../pages/_affiliate/will/estate/backup-beneficiaries/_id.vue' /* webpackChunkName: "pages/_affiliate/will/estate/backup-beneficiaries/_id" */))
const _c7fe9a6e = () => interopDefault(import('../../../pages/_affiliate/will/estate/backup-distribution/_id.vue' /* webpackChunkName: "pages/_affiliate/will/estate/backup-distribution/_id" */))
const _f81b023e = () => interopDefault(import('../../../pages/_affiliate/auth/callback.vue' /* webpackChunkName: "pages/_affiliate/auth/callback" */))
const _fd214f0a = () => interopDefault(import('../../../pages/_affiliate/auth/home.vue' /* webpackChunkName: "pages/_affiliate/auth/home" */))
const _7bd3ecaa = () => interopDefault(import('../../../pages/_affiliate/log-in/2fa/index.vue' /* webpackChunkName: "pages/_affiliate/log-in/2fa/index" */))
const _6123114a = () => interopDefault(import('../../../pages/_affiliate/onboarding/end-of-life/index.vue' /* webpackChunkName: "pages/_affiliate/onboarding/end-of-life/index" */))
const _e1ef5468 = () => interopDefault(import('../../../pages/_affiliate/onboarding/poa/index.vue' /* webpackChunkName: "pages/_affiliate/onboarding/poa/index" */))
const _0b768817 = () => interopDefault(import('../../../pages/_affiliate/onboarding/user/index.vue' /* webpackChunkName: "pages/_affiliate/onboarding/user/index" */))
const _08d630d5 = () => interopDefault(import('../../../pages/_affiliate/log-in/2fa/setup.vue' /* webpackChunkName: "pages/_affiliate/log-in/2fa/setup" */))
const _be0cad56 = () => interopDefault(import('../../../pages/_affiliate/onboarding/end-of-life/_category.vue' /* webpackChunkName: "pages/_affiliate/onboarding/end-of-life/_category" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth/callback",
    component: _4847caa6,
    name: "auth-callback___au"
  }, {
    path: "/auth/home",
    component: _ae396280,
    name: "auth-home___au"
  }, {
    path: "/nz/auth/callback",
    component: _4847caa6,
    name: "auth-callback___nz"
  }, {
    path: "/nz/auth/home",
    component: _ae396280,
    name: "auth-home___nz"
  }, {
    path: "/nz/:affiliate",
    component: _2e6880e7,
    name: "affiliate___nz"
  }, {
    path: "/nz/:affiliate?/admin",
    component: _5fd7d4e4,
    children: [{
      path: "",
      component: _86fbbf32,
      name: "affiliate-admin___nz"
    }, {
      path: "coupons",
      component: _497398e5,
      name: "affiliate-admin-coupons___nz"
    }, {
      path: "cremations",
      component: _2df57af3,
      name: "affiliate-admin-cremations___nz"
    }, {
      path: "end-of-life-categories",
      component: _ef4ca5f2,
      name: "affiliate-admin-end-of-life-categories___nz"
    }, {
      path: "generic-checkout",
      component: _4270803a,
      name: "affiliate-admin-generic-checkout___nz"
    }, {
      path: "institutions",
      component: _7abfb039,
      name: "affiliate-admin-institutions___nz"
    }, {
      path: "partnerships",
      component: _51c93b6d,
      name: "affiliate-admin-partnerships___nz"
    }, {
      path: "reporting",
      component: _11f3b186,
      name: "affiliate-admin-reporting___nz"
    }, {
      path: "submissions",
      component: _57881b7f,
      name: "affiliate-admin-submissions___nz"
    }, {
      path: "users",
      component: _00875760,
      name: "affiliate-admin-users___nz"
    }, {
      path: "coupons/:id",
      component: _026c908d,
      name: "affiliate-admin-coupons-id___nz"
    }, {
      path: "cremations/:id",
      component: _a308c3ca,
      name: "affiliate-admin-cremations-id___nz"
    }, {
      path: "end-of-life-categories/:id?",
      component: _4ead452f,
      name: "affiliate-admin-end-of-life-categories-id___nz"
    }, {
      path: "institutions/:id",
      component: _fe83263e,
      name: "affiliate-admin-institutions-id___nz"
    }, {
      path: "partnerships/:id",
      component: _d94d95d6,
      name: "affiliate-admin-partnerships-id___nz"
    }, {
      path: "submissions/:id",
      component: _1914f1a7,
      name: "affiliate-admin-submissions-id___nz"
    }, {
      path: "users/:id",
      component: _72c3b1c8,
      name: "affiliate-admin-users-id___nz"
    }]
  }, {
    path: "/nz/:affiliate?/checkout",
    component: _4cd2bd7e,
    name: "affiliate-checkout___nz",
    children: [{
      path: "generic",
      component: _07743268,
      name: "affiliate-checkout-generic___nz"
    }, {
      path: "gifts",
      component: _1d4a21b8,
      name: "affiliate-checkout-gifts___nz"
    }, {
      path: "poa",
      component: _6aeaa277,
      name: "affiliate-checkout-poa___nz"
    }, {
      path: "unlock",
      component: _2fd22f85,
      name: "affiliate-checkout-unlock___nz"
    }, {
      path: "update-card",
      component: _306eb149,
      name: "affiliate-checkout-update-card___nz"
    }, {
      path: "will",
      component: _520b0fda,
      name: "affiliate-checkout-will___nz"
    }, {
      path: "generic/thanks",
      component: _23f564bf,
      name: "affiliate-checkout-generic-thanks___nz"
    }, {
      path: "gifts/thank-you",
      component: _5a3870bc,
      name: "affiliate-checkout-gifts-thank-you___nz"
    }, {
      path: "gifts/thanks",
      component: _23788753,
      name: "affiliate-checkout-gifts-thanks___nz"
    }, {
      path: "poa/thank-you",
      component: _66c7d0e1,
      name: "affiliate-checkout-poa-thank-you___nz"
    }, {
      path: "poa/thanks",
      component: _ec2fc318,
      name: "affiliate-checkout-poa-thanks___nz"
    }, {
      path: "unlock/thanks",
      component: _61f23326,
      name: "affiliate-checkout-unlock-thanks___nz"
    }, {
      path: "update-card/thanks",
      component: _74e5e9e2,
      name: "affiliate-checkout-update-card-thanks___nz"
    }, {
      path: "will/thank-you",
      component: _15090f06,
      name: "affiliate-checkout-will-thank-you___nz"
    }, {
      path: "will/thanks",
      component: _c05a0750,
      name: "affiliate-checkout-will-thanks___nz"
    }]
  }, {
    path: "/nz/:affiliate?/cremations",
    component: _5e521020,
    name: "affiliate-cremations___nz",
    children: [{
      path: "at-need",
      component: _33531014,
      name: "affiliate-cremations-at-need___nz"
    }, {
      path: "complete-quote",
      component: _8ab4024c,
      name: "affiliate-cremations-complete-quote___nz"
    }, {
      path: "complete-quote/arrange-payment",
      component: _5981956d,
      name: "affiliate-cremations-complete-quote-arrange-payment___nz"
    }, {
      path: "complete-quote/contract-preview",
      component: _228a87b5,
      name: "affiliate-cremations-complete-quote-contract-preview___nz"
    }, {
      path: "at-need/documentation/final/:id?",
      component: _2767df64,
      name: "affiliate-cremations-at-need-documentation-final-id___nz"
    }, {
      path: "at-need/documentation/initial/:id?",
      component: _897db248,
      name: "affiliate-cremations-at-need-documentation-initial-id___nz"
    }, {
      path: "at-need/address/:id",
      component: _d9d43b3e,
      name: "affiliate-cremations-at-need-address-id___nz"
    }, {
      path: "at-need/authorisation/:id",
      component: _5d6a870d,
      name: "affiliate-cremations-at-need-authorisation-id___nz"
    }, {
      path: "at-need/care/:id",
      component: _9201ef2c,
      name: "affiliate-cremations-at-need-care-id___nz"
    }, {
      path: "at-need/children/:id",
      component: _5e3dbb50,
      name: "affiliate-cremations-at-need-children-id___nz"
    }, {
      path: "at-need/deceased/:id",
      component: _f1877266,
      name: "affiliate-cremations-at-need-deceased-id___nz"
    }, {
      path: "at-need/informant/:id",
      component: _186bafcb,
      name: "affiliate-cremations-at-need-informant-id___nz"
    }, {
      path: "at-need/instructions/:id",
      component: _1ac2e8fe,
      name: "affiliate-cremations-at-need-instructions-id___nz"
    }, {
      path: "at-need/life/:id",
      component: _2ff22155,
      name: "affiliate-cremations-at-need-life-id___nz"
    }, {
      path: "at-need/parents/:id",
      component: _08d06e76,
      name: "affiliate-cremations-at-need-parents-id___nz"
    }, {
      path: "at-need/passing/:id",
      component: _64b5b0c4,
      name: "affiliate-cremations-at-need-passing-id___nz"
    }, {
      path: "at-need/relationships/:id",
      component: _f4b0cdb0,
      name: "affiliate-cremations-at-need-relationships-id___nz"
    }, {
      path: "at-need/:id?",
      component: _7ece077c,
      name: "affiliate-cremations-at-need-id___nz"
    }]
  }, {
    path: "/nz/:affiliate?/dashboard",
    component: _ba3fe9ae,
    children: [{
      path: "",
      component: _6c17ceec,
      name: "affiliate-dashboard___nz"
    }, {
      path: "account-settings",
      component: _5951bf19,
      name: "affiliate-dashboard-account-settings___nz"
    }, {
      path: "files",
      component: _4ed00611,
      name: "affiliate-dashboard-files___nz"
    }, {
      path: "invites",
      component: _5baba424,
      name: "affiliate-dashboard-invites___nz"
    }]
  }, {
    path: "/nz/:affiliate?/end-of-life",
    component: _50639195,
    name: "affiliate-end-of-life___nz",
    children: [{
      path: ":rootcategory",
      component: _15476388,
      name: "affiliate-end-of-life-rootcategory___nz"
    }, {
      path: ":rootcategory?/:category",
      component: _0b5e38d6,
      name: "affiliate-end-of-life-rootcategory-category___nz"
    }, {
      path: ":rootcategory?/:category/:subcategory",
      component: _5d74a6ee,
      name: "affiliate-end-of-life-rootcategory-category-subcategory___nz"
    }]
  }, {
    path: "/nz/:affiliate?/forgot-password",
    component: _03eeff4c,
    name: "affiliate-forgot-password___nz"
  }, {
    path: "/nz/:affiliate?/get-started",
    component: _7c64e75f,
    children: [{
      path: "",
      component: _16182aa2,
      name: "affiliate-get-started___nz"
    }]
  }, {
    path: "/nz/:affiliate?/log-in",
    component: _2ccd44cc,
    name: "affiliate-log-in___nz"
  }, {
    path: "/nz/:affiliate?/log-out",
    component: _ecba7ecc,
    name: "affiliate-log-out___nz"
  }, {
    path: "/nz/:affiliate?/maintenance",
    component: _69e7b0e8,
    name: "affiliate-maintenance___nz"
  }, {
    path: "/nz/:affiliate?/poa",
    component: _157c4d97,
    children: [{
      path: "",
      component: _e02ff24c,
      name: "affiliate-poa___nz"
    }, {
      path: "about-yourself",
      component: _a6ec5e32,
      children: [{
        path: "",
        component: _4179ce2a,
        name: "affiliate-poa-about-yourself___nz"
      }, {
        path: "address",
        component: _6707f04c,
        name: "affiliate-poa-about-yourself-address___nz"
      }, {
        path: "date-of-birth",
        component: _06c1ea40,
        name: "affiliate-poa-about-yourself-date-of-birth___nz"
      }, {
        path: "phone",
        component: _344634c6,
        name: "affiliate-poa-about-yourself-phone___nz"
      }]
    }, {
      path: "financial",
      component: _a05361de,
      children: [{
        path: "",
        component: _ca94f658,
        name: "affiliate-poa-financial___nz"
      }, {
        path: "limitations",
        component: _663dbeca,
        name: "affiliate-poa-financial-limitations___nz"
      }, {
        path: "primary-decision-makers",
        component: _234b11f7,
        name: "affiliate-poa-financial-primary-decision-makers___nz"
      }, {
        path: "primary-decisions",
        component: _6288820e,
        name: "affiliate-poa-financial-primary-decisions___nz"
      }, {
        path: "spending",
        component: _4fec6fb2,
        name: "affiliate-poa-financial-spending___nz"
      }, {
        path: "substitute-decision-makers",
        component: _2b15347b,
        name: "affiliate-poa-financial-substitute-decision-makers___nz"
      }, {
        path: "substitutes",
        component: _5f92d81b,
        name: "affiliate-poa-financial-substitutes___nz"
      }]
    }, {
      path: "medical",
      component: _dc08b5ce,
      children: [{
        path: "",
        component: _e7979648,
        name: "affiliate-poa-medical___nz"
      }, {
        path: "limitations",
        component: _17cdaaa3,
        name: "affiliate-poa-medical-limitations___nz"
      }, {
        path: "preferences",
        component: _31914a82,
        name: "affiliate-poa-medical-preferences___nz"
      }, {
        path: "primary-decision-makers",
        component: _fc5e6002,
        name: "affiliate-poa-medical-primary-decision-makers___nz"
      }, {
        path: "primary-decisions",
        component: _e0d133d4,
        name: "affiliate-poa-medical-primary-decisions___nz"
      }, {
        path: "substitute-decision-makers",
        component: _4e5b4d1a,
        name: "affiliate-poa-medical-substitute-decision-makers___nz"
      }, {
        path: "substitutes",
        component: _ab013bba,
        name: "affiliate-poa-medical-substitutes___nz"
      }]
    }]
  }, {
    path: "/nz/:affiliate?/verify",
    component: _372cc7b4,
    name: "affiliate-verify___nz"
  }, {
    path: "/nz/:affiliate?/will",
    component: _49de874d,
    children: [{
      path: "",
      component: _51a9a010,
      name: "affiliate-will___nz"
    }, {
      path: "assets",
      component: _a785e310,
      name: "affiliate-will-assets___nz"
    }, {
      path: "charity-consent",
      component: _e7cdf134,
      name: "affiliate-will-charity-consent___nz"
    }, {
      path: "completion",
      component: _16153ae4,
      name: "affiliate-will-completion___nz"
    }, {
      path: "estate",
      component: _35d46f01,
      name: "affiliate-will-estate___nz"
    }, {
      path: "executors",
      component: _3b2faf41,
      name: "affiliate-will-executors___nz"
    }, {
      path: "funeral",
      component: _02fd6598,
      name: "affiliate-will-funeral___nz"
    }, {
      path: "gifts",
      component: _410d55c4,
      name: "affiliate-will-gifts___nz"
    }, {
      path: "about-yourself/address",
      component: _335dac54,
      name: "affiliate-will-about-yourself-address___nz"
    }, {
      path: "about-yourself/date-of-birth",
      component: _2f15162c,
      name: "affiliate-will-about-yourself-date-of-birth___nz"
    }, {
      path: "about-yourself/name",
      component: _96c5e2ce,
      name: "affiliate-will-about-yourself-name___nz"
    }, {
      path: "about-yourself/partner",
      component: _7281e0aa,
      name: "affiliate-will-about-yourself-partner___nz"
    }, {
      path: "about-yourself/phone",
      component: _5ac448d0,
      name: "affiliate-will-about-yourself-phone___nz"
    }, {
      path: "assets/liabilities",
      component: _12a93dde,
      name: "affiliate-will-assets-liabilities___nz"
    }, {
      path: "assets/notes",
      component: _4791a4e7,
      name: "affiliate-will-assets-notes___nz"
    }, {
      path: "estate/beneficiaries",
      component: _ce84fe1c,
      name: "affiliate-will-estate-beneficiaries___nz"
    }, {
      path: "estate/distribution",
      component: _0388caa5,
      name: "affiliate-will-estate-distribution___nz"
    }, {
      path: "estate/include-charity",
      component: _2f7aca62,
      name: "affiliate-will-estate-include-charity___nz"
    }, {
      path: "executors/backup",
      component: _6d9cf53a,
      name: "affiliate-will-executors-backup___nz"
    }, {
      path: "executors/options",
      component: _088f6d4d,
      name: "affiliate-will-executors-options___nz"
    }, {
      path: "executors/primary",
      component: _2da8ba9e,
      name: "affiliate-will-executors-primary___nz"
    }, {
      path: "executors/primary-contact",
      component: _d726c0f8,
      name: "affiliate-will-executors-primary-contact___nz"
    }, {
      path: "executors/professional-terms",
      component: _016b6502,
      name: "affiliate-will-executors-professional-terms___nz"
    }, {
      path: "funeral/location",
      component: _4c619442,
      name: "affiliate-will-funeral-location___nz"
    }, {
      path: "funeral/other-requests",
      component: _301ea08b,
      name: "affiliate-will-funeral-other-requests___nz"
    }, {
      path: "gifts/include-charity",
      component: _77805965,
      name: "affiliate-will-gifts-include-charity___nz"
    }, {
      path: "guardians/backup",
      component: _284fcdbe,
      name: "affiliate-will-guardians-backup___nz"
    }, {
      path: "guardians/pet-care-fund",
      component: _37359378,
      name: "affiliate-will-guardians-pet-care-fund___nz"
    }, {
      path: "guardians/pet-guardians",
      component: _a3e98a76,
      name: "affiliate-will-guardians-pet-guardians___nz"
    }, {
      path: "guardians/primary",
      component: _1b5786b3,
      name: "affiliate-will-guardians-primary___nz"
    }, {
      path: "guardians/your-children",
      component: _f7848e6c,
      name: "affiliate-will-guardians-your-children___nz"
    }, {
      path: "guardians/your-pets",
      component: _16c1fcff,
      name: "affiliate-will-guardians-your-pets___nz"
    }, {
      path: "estate/backup-beneficiaries/:id?",
      component: _0231a078,
      name: "affiliate-will-estate-backup-beneficiaries-id___nz"
    }, {
      path: "estate/backup-distribution/:id?",
      component: _c7fe9a6e,
      name: "affiliate-will-estate-backup-distribution-id___nz"
    }]
  }, {
    path: "/nz/:affiliate?/auth/callback",
    component: _f81b023e,
    name: "affiliate-auth-callback___nz"
  }, {
    path: "/nz/:affiliate?/auth/home",
    component: _fd214f0a,
    name: "affiliate-auth-home___nz"
  }, {
    path: "/nz/:affiliate?/log-in/2fa",
    component: _7bd3ecaa,
    name: "affiliate-log-in-2fa___nz"
  }, {
    path: "/nz/:affiliate?/onboarding/end-of-life",
    component: _6123114a,
    name: "affiliate-onboarding-end-of-life___nz"
  }, {
    path: "/nz/:affiliate?/onboarding/poa",
    component: _e1ef5468,
    name: "affiliate-onboarding-poa___nz"
  }, {
    path: "/nz/:affiliate?/onboarding/user",
    component: _0b768817,
    name: "affiliate-onboarding-user___nz"
  }, {
    path: "/nz/:affiliate?/log-in/2fa/setup",
    component: _08d630d5,
    name: "affiliate-log-in-2fa-setup___nz"
  }, {
    path: "/nz/:affiliate?/onboarding/end-of-life/:category?",
    component: _be0cad56,
    name: "affiliate-onboarding-end-of-life-category___nz"
  }, {
    path: "/:affiliate",
    component: _2e6880e7,
    name: "affiliate___au"
  }, {
    path: "/:affiliate?/admin",
    component: _5fd7d4e4,
    children: [{
      path: "",
      component: _86fbbf32,
      name: "affiliate-admin___au"
    }, {
      path: "coupons",
      component: _497398e5,
      name: "affiliate-admin-coupons___au"
    }, {
      path: "cremations",
      component: _2df57af3,
      name: "affiliate-admin-cremations___au"
    }, {
      path: "end-of-life-categories",
      component: _ef4ca5f2,
      name: "affiliate-admin-end-of-life-categories___au"
    }, {
      path: "generic-checkout",
      component: _4270803a,
      name: "affiliate-admin-generic-checkout___au"
    }, {
      path: "institutions",
      component: _7abfb039,
      name: "affiliate-admin-institutions___au"
    }, {
      path: "partnerships",
      component: _51c93b6d,
      name: "affiliate-admin-partnerships___au"
    }, {
      path: "reporting",
      component: _11f3b186,
      name: "affiliate-admin-reporting___au"
    }, {
      path: "submissions",
      component: _57881b7f,
      name: "affiliate-admin-submissions___au"
    }, {
      path: "users",
      component: _00875760,
      name: "affiliate-admin-users___au"
    }, {
      path: "coupons/:id",
      component: _026c908d,
      name: "affiliate-admin-coupons-id___au"
    }, {
      path: "cremations/:id",
      component: _a308c3ca,
      name: "affiliate-admin-cremations-id___au"
    }, {
      path: "end-of-life-categories/:id?",
      component: _4ead452f,
      name: "affiliate-admin-end-of-life-categories-id___au"
    }, {
      path: "institutions/:id",
      component: _fe83263e,
      name: "affiliate-admin-institutions-id___au"
    }, {
      path: "partnerships/:id",
      component: _d94d95d6,
      name: "affiliate-admin-partnerships-id___au"
    }, {
      path: "submissions/:id",
      component: _1914f1a7,
      name: "affiliate-admin-submissions-id___au"
    }, {
      path: "users/:id",
      component: _72c3b1c8,
      name: "affiliate-admin-users-id___au"
    }]
  }, {
    path: "/:affiliate?/checkout",
    component: _4cd2bd7e,
    name: "affiliate-checkout___au",
    children: [{
      path: "generic",
      component: _07743268,
      name: "affiliate-checkout-generic___au"
    }, {
      path: "gifts",
      component: _1d4a21b8,
      name: "affiliate-checkout-gifts___au"
    }, {
      path: "poa",
      component: _6aeaa277,
      name: "affiliate-checkout-poa___au"
    }, {
      path: "unlock",
      component: _2fd22f85,
      name: "affiliate-checkout-unlock___au"
    }, {
      path: "update-card",
      component: _306eb149,
      name: "affiliate-checkout-update-card___au"
    }, {
      path: "will",
      component: _520b0fda,
      name: "affiliate-checkout-will___au"
    }, {
      path: "generic/thanks",
      component: _23f564bf,
      name: "affiliate-checkout-generic-thanks___au"
    }, {
      path: "gifts/thank-you",
      component: _5a3870bc,
      name: "affiliate-checkout-gifts-thank-you___au"
    }, {
      path: "gifts/thanks",
      component: _23788753,
      name: "affiliate-checkout-gifts-thanks___au"
    }, {
      path: "poa/thank-you",
      component: _66c7d0e1,
      name: "affiliate-checkout-poa-thank-you___au"
    }, {
      path: "poa/thanks",
      component: _ec2fc318,
      name: "affiliate-checkout-poa-thanks___au"
    }, {
      path: "unlock/thanks",
      component: _61f23326,
      name: "affiliate-checkout-unlock-thanks___au"
    }, {
      path: "update-card/thanks",
      component: _74e5e9e2,
      name: "affiliate-checkout-update-card-thanks___au"
    }, {
      path: "will/thank-you",
      component: _15090f06,
      name: "affiliate-checkout-will-thank-you___au"
    }, {
      path: "will/thanks",
      component: _c05a0750,
      name: "affiliate-checkout-will-thanks___au"
    }]
  }, {
    path: "/:affiliate?/cremations",
    component: _5e521020,
    name: "affiliate-cremations___au",
    children: [{
      path: "at-need",
      component: _33531014,
      name: "affiliate-cremations-at-need___au"
    }, {
      path: "complete-quote",
      component: _8ab4024c,
      name: "affiliate-cremations-complete-quote___au"
    }, {
      path: "complete-quote/arrange-payment",
      component: _5981956d,
      name: "affiliate-cremations-complete-quote-arrange-payment___au"
    }, {
      path: "complete-quote/contract-preview",
      component: _228a87b5,
      name: "affiliate-cremations-complete-quote-contract-preview___au"
    }, {
      path: "at-need/documentation/final/:id?",
      component: _2767df64,
      name: "affiliate-cremations-at-need-documentation-final-id___au"
    }, {
      path: "at-need/documentation/initial/:id?",
      component: _897db248,
      name: "affiliate-cremations-at-need-documentation-initial-id___au"
    }, {
      path: "at-need/address/:id",
      component: _d9d43b3e,
      name: "affiliate-cremations-at-need-address-id___au"
    }, {
      path: "at-need/authorisation/:id",
      component: _5d6a870d,
      name: "affiliate-cremations-at-need-authorisation-id___au"
    }, {
      path: "at-need/care/:id",
      component: _9201ef2c,
      name: "affiliate-cremations-at-need-care-id___au"
    }, {
      path: "at-need/children/:id",
      component: _5e3dbb50,
      name: "affiliate-cremations-at-need-children-id___au"
    }, {
      path: "at-need/deceased/:id",
      component: _f1877266,
      name: "affiliate-cremations-at-need-deceased-id___au"
    }, {
      path: "at-need/informant/:id",
      component: _186bafcb,
      name: "affiliate-cremations-at-need-informant-id___au"
    }, {
      path: "at-need/instructions/:id",
      component: _1ac2e8fe,
      name: "affiliate-cremations-at-need-instructions-id___au"
    }, {
      path: "at-need/life/:id",
      component: _2ff22155,
      name: "affiliate-cremations-at-need-life-id___au"
    }, {
      path: "at-need/parents/:id",
      component: _08d06e76,
      name: "affiliate-cremations-at-need-parents-id___au"
    }, {
      path: "at-need/passing/:id",
      component: _64b5b0c4,
      name: "affiliate-cremations-at-need-passing-id___au"
    }, {
      path: "at-need/relationships/:id",
      component: _f4b0cdb0,
      name: "affiliate-cremations-at-need-relationships-id___au"
    }, {
      path: "at-need/:id?",
      component: _7ece077c,
      name: "affiliate-cremations-at-need-id___au"
    }]
  }, {
    path: "/:affiliate?/dashboard",
    component: _ba3fe9ae,
    children: [{
      path: "",
      component: _6c17ceec,
      name: "affiliate-dashboard___au"
    }, {
      path: "account-settings",
      component: _5951bf19,
      name: "affiliate-dashboard-account-settings___au"
    }, {
      path: "files",
      component: _4ed00611,
      name: "affiliate-dashboard-files___au"
    }, {
      path: "invites",
      component: _5baba424,
      name: "affiliate-dashboard-invites___au"
    }]
  }, {
    path: "/:affiliate?/end-of-life",
    component: _50639195,
    name: "affiliate-end-of-life___au",
    children: [{
      path: ":rootcategory",
      component: _15476388,
      name: "affiliate-end-of-life-rootcategory___au"
    }, {
      path: ":rootcategory?/:category",
      component: _0b5e38d6,
      name: "affiliate-end-of-life-rootcategory-category___au"
    }, {
      path: ":rootcategory?/:category/:subcategory",
      component: _5d74a6ee,
      name: "affiliate-end-of-life-rootcategory-category-subcategory___au"
    }]
  }, {
    path: "/:affiliate?/forgot-password",
    component: _03eeff4c,
    name: "affiliate-forgot-password___au"
  }, {
    path: "/:affiliate?/get-started",
    component: _7c64e75f,
    children: [{
      path: "",
      component: _16182aa2,
      name: "affiliate-get-started___au"
    }]
  }, {
    path: "/:affiliate?/log-in",
    component: _2ccd44cc,
    name: "affiliate-log-in___au"
  }, {
    path: "/:affiliate?/log-out",
    component: _ecba7ecc,
    name: "affiliate-log-out___au"
  }, {
    path: "/:affiliate?/maintenance",
    component: _69e7b0e8,
    name: "affiliate-maintenance___au"
  }, {
    path: "/:affiliate?/poa",
    component: _157c4d97,
    children: [{
      path: "",
      component: _e02ff24c,
      name: "affiliate-poa___au"
    }, {
      path: "about-yourself",
      component: _a6ec5e32,
      children: [{
        path: "",
        component: _4179ce2a,
        name: "affiliate-poa-about-yourself___au"
      }, {
        path: "address",
        component: _6707f04c,
        name: "affiliate-poa-about-yourself-address___au"
      }, {
        path: "date-of-birth",
        component: _06c1ea40,
        name: "affiliate-poa-about-yourself-date-of-birth___au"
      }, {
        path: "phone",
        component: _344634c6,
        name: "affiliate-poa-about-yourself-phone___au"
      }]
    }, {
      path: "financial",
      component: _a05361de,
      children: [{
        path: "",
        component: _ca94f658,
        name: "affiliate-poa-financial___au"
      }, {
        path: "limitations",
        component: _663dbeca,
        name: "affiliate-poa-financial-limitations___au"
      }, {
        path: "primary-decision-makers",
        component: _234b11f7,
        name: "affiliate-poa-financial-primary-decision-makers___au"
      }, {
        path: "primary-decisions",
        component: _6288820e,
        name: "affiliate-poa-financial-primary-decisions___au"
      }, {
        path: "spending",
        component: _4fec6fb2,
        name: "affiliate-poa-financial-spending___au"
      }, {
        path: "substitute-decision-makers",
        component: _2b15347b,
        name: "affiliate-poa-financial-substitute-decision-makers___au"
      }, {
        path: "substitutes",
        component: _5f92d81b,
        name: "affiliate-poa-financial-substitutes___au"
      }]
    }, {
      path: "medical",
      component: _dc08b5ce,
      children: [{
        path: "",
        component: _e7979648,
        name: "affiliate-poa-medical___au"
      }, {
        path: "limitations",
        component: _17cdaaa3,
        name: "affiliate-poa-medical-limitations___au"
      }, {
        path: "preferences",
        component: _31914a82,
        name: "affiliate-poa-medical-preferences___au"
      }, {
        path: "primary-decision-makers",
        component: _fc5e6002,
        name: "affiliate-poa-medical-primary-decision-makers___au"
      }, {
        path: "primary-decisions",
        component: _e0d133d4,
        name: "affiliate-poa-medical-primary-decisions___au"
      }, {
        path: "substitute-decision-makers",
        component: _4e5b4d1a,
        name: "affiliate-poa-medical-substitute-decision-makers___au"
      }, {
        path: "substitutes",
        component: _ab013bba,
        name: "affiliate-poa-medical-substitutes___au"
      }]
    }]
  }, {
    path: "/:affiliate?/verify",
    component: _372cc7b4,
    name: "affiliate-verify___au"
  }, {
    path: "/:affiliate?/will",
    component: _49de874d,
    children: [{
      path: "",
      component: _51a9a010,
      name: "affiliate-will___au"
    }, {
      path: "assets",
      component: _a785e310,
      name: "affiliate-will-assets___au"
    }, {
      path: "charity-consent",
      component: _e7cdf134,
      name: "affiliate-will-charity-consent___au"
    }, {
      path: "completion",
      component: _16153ae4,
      name: "affiliate-will-completion___au"
    }, {
      path: "estate",
      component: _35d46f01,
      name: "affiliate-will-estate___au"
    }, {
      path: "executors",
      component: _3b2faf41,
      name: "affiliate-will-executors___au"
    }, {
      path: "funeral",
      component: _02fd6598,
      name: "affiliate-will-funeral___au"
    }, {
      path: "gifts",
      component: _410d55c4,
      name: "affiliate-will-gifts___au"
    }, {
      path: "about-yourself/address",
      component: _335dac54,
      name: "affiliate-will-about-yourself-address___au"
    }, {
      path: "about-yourself/date-of-birth",
      component: _2f15162c,
      name: "affiliate-will-about-yourself-date-of-birth___au"
    }, {
      path: "about-yourself/name",
      component: _96c5e2ce,
      name: "affiliate-will-about-yourself-name___au"
    }, {
      path: "about-yourself/partner",
      component: _7281e0aa,
      name: "affiliate-will-about-yourself-partner___au"
    }, {
      path: "about-yourself/phone",
      component: _5ac448d0,
      name: "affiliate-will-about-yourself-phone___au"
    }, {
      path: "assets/liabilities",
      component: _12a93dde,
      name: "affiliate-will-assets-liabilities___au"
    }, {
      path: "assets/notes",
      component: _4791a4e7,
      name: "affiliate-will-assets-notes___au"
    }, {
      path: "estate/beneficiaries",
      component: _ce84fe1c,
      name: "affiliate-will-estate-beneficiaries___au"
    }, {
      path: "estate/distribution",
      component: _0388caa5,
      name: "affiliate-will-estate-distribution___au"
    }, {
      path: "estate/include-charity",
      component: _2f7aca62,
      name: "affiliate-will-estate-include-charity___au"
    }, {
      path: "executors/backup",
      component: _6d9cf53a,
      name: "affiliate-will-executors-backup___au"
    }, {
      path: "executors/options",
      component: _088f6d4d,
      name: "affiliate-will-executors-options___au"
    }, {
      path: "executors/primary",
      component: _2da8ba9e,
      name: "affiliate-will-executors-primary___au"
    }, {
      path: "executors/primary-contact",
      component: _d726c0f8,
      name: "affiliate-will-executors-primary-contact___au"
    }, {
      path: "executors/professional-terms",
      component: _016b6502,
      name: "affiliate-will-executors-professional-terms___au"
    }, {
      path: "funeral/location",
      component: _4c619442,
      name: "affiliate-will-funeral-location___au"
    }, {
      path: "funeral/other-requests",
      component: _301ea08b,
      name: "affiliate-will-funeral-other-requests___au"
    }, {
      path: "gifts/include-charity",
      component: _77805965,
      name: "affiliate-will-gifts-include-charity___au"
    }, {
      path: "guardians/backup",
      component: _284fcdbe,
      name: "affiliate-will-guardians-backup___au"
    }, {
      path: "guardians/pet-care-fund",
      component: _37359378,
      name: "affiliate-will-guardians-pet-care-fund___au"
    }, {
      path: "guardians/pet-guardians",
      component: _a3e98a76,
      name: "affiliate-will-guardians-pet-guardians___au"
    }, {
      path: "guardians/primary",
      component: _1b5786b3,
      name: "affiliate-will-guardians-primary___au"
    }, {
      path: "guardians/your-children",
      component: _f7848e6c,
      name: "affiliate-will-guardians-your-children___au"
    }, {
      path: "guardians/your-pets",
      component: _16c1fcff,
      name: "affiliate-will-guardians-your-pets___au"
    }, {
      path: "estate/backup-beneficiaries/:id?",
      component: _0231a078,
      name: "affiliate-will-estate-backup-beneficiaries-id___au"
    }, {
      path: "estate/backup-distribution/:id?",
      component: _c7fe9a6e,
      name: "affiliate-will-estate-backup-distribution-id___au"
    }]
  }, {
    path: "/:affiliate?/auth/callback",
    component: _f81b023e,
    name: "affiliate-auth-callback___au"
  }, {
    path: "/:affiliate?/auth/home",
    component: _fd214f0a,
    name: "affiliate-auth-home___au"
  }, {
    path: "/:affiliate?/log-in/2fa",
    component: _7bd3ecaa,
    name: "affiliate-log-in-2fa___au"
  }, {
    path: "/:affiliate?/onboarding/end-of-life",
    component: _6123114a,
    name: "affiliate-onboarding-end-of-life___au"
  }, {
    path: "/:affiliate?/onboarding/poa",
    component: _e1ef5468,
    name: "affiliate-onboarding-poa___au"
  }, {
    path: "/:affiliate?/onboarding/user",
    component: _0b768817,
    name: "affiliate-onboarding-user___au"
  }, {
    path: "/:affiliate?/log-in/2fa/setup",
    component: _08d630d5,
    name: "affiliate-log-in-2fa-setup___au"
  }, {
    path: "/:affiliate?/onboarding/end-of-life/:category?",
    component: _be0cad56,
    name: "affiliate-onboarding-end-of-life-category___au"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
